import { NavLink, useNavigate } from "react-router-dom";
import { House, ListDashes, ChartBar, DotsThreeCircle, Plus } from "@phosphor-icons/react";

const Item = ({ to, icon: Icon, label, testId }) => (
  <NavLink
    to={to}
    data-testid={testId}
    className={({ isActive }) =>
      `flex flex-col items-center justify-center gap-0.5 flex-1 h-full min-w-[44px] ${
        isActive ? "text-foreground" : "text-muted-foreground"
      }`
    }
  >
    {({ isActive }) => (
      <>
        <Icon size={24} weight={isActive ? "fill" : "regular"} />
        <span className="text-[10px] font-medium">{label}</span>
      </>
    )}
  </NavLink>
);

export const BottomNav = () => {
  const navigate = useNavigate();
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 max-w-md mx-auto bg-white/80 backdrop-blur-xl border-t border-border safe-bottom">
      <div className="flex items-center h-16 relative">
        <Item to="/" icon={House} label="Home" testId="nav-dashboard" />
        <Item to="/transactions" icon={ListDashes} label="Activity" testId="nav-transactions" />
        <div className="flex-1 flex justify-center">
          <button
            data-testid="fab-add-transaction"
            onClick={() => navigate("/add")}
            className="h-14 w-14 -mt-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg active:scale-[0.95] transition-transform duration-150"
            aria-label="Add transaction"
          >
            <Plus size={26} weight="bold" />
          </button>
        </div>
        <Item to="/reports" icon={ChartBar} label="Reports" testId="nav-reports" />
        <Item to="/more" icon={DotsThreeCircle} label="More" testId="nav-more" />
      </div>
    </nav>
  );
};
